module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/chieti.13efce0462c3e4feaba31f24ee54e9ba.jpg";